import { connect } from 'react-redux';
import {
    addFavouriteProjectIssue,
    fetchProjectIssues,
    filterProjectIssue,
    getAllProjectIssue,
    getUnselectedAllProjectIssue,
    handleProjectIssueRequestClose,
    hideProjectIssueLoader,
    showProjectIssueLoader,
    onAddProjectIssue,
    onAddJiraProjectIssue,
    onAllProjectIssueSelect,
    onProjectIssueClose,
    onJiraProjectIssueClose,
    onProjectIssueSelect,
    onDeleteProjectIssue,
    onFilterSelectedProjectIssue,
    onFilterProjectIssueOptionSelect,
    onSaveProjectIssue,
    onSaveJiraProjectIssue,
    onToggleProjectIssueDrawer,
    updateSearchProjectIssue,
    setProjectIssue,
} from 'actions/projectIssue';

import Component from './component';


export const mapStateToProps = ({ projects, projectIssues, settings }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        projectIssue,
        searchProjectIssue,
        filterOption,
        allProjectIssue,
        projectIssueList,
        selectedProjectIssue,
        selectedProjectIssues,
        addProjectIssueState,
        addJiraProjectIssueState,
    } = projectIssues;
    const {
        selectedProject,
    } = projects;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        projectIssue,
        searchProjectIssue,
        filterOption,
        allProjectIssue,
        projectIssueList,
        selectedProjectIssue,
        selectedProjectIssues,
        addProjectIssueState,
        addJiraProjectIssueState,
        selectedProject,
    };
};
export default connect(mapStateToProps, {
    fetchProjectIssues,
    addFavouriteProjectIssue,
    onProjectIssueSelect,
    onAddProjectIssue,
    onAddJiraProjectIssue,
    onProjectIssueClose,
    onJiraProjectIssueClose,
    onFilterProjectIssueOptionSelect,
    onSaveProjectIssue,
    onSaveJiraProjectIssue,
    onDeleteProjectIssue,
    onFilterSelectedProjectIssue,
    filterProjectIssue,
    getAllProjectIssue,
    getUnselectedAllProjectIssue,
    onAllProjectIssueSelect,
    updateSearchProjectIssue,
    onToggleProjectIssueDrawer,
    handleProjectIssueRequestClose,
    hideProjectIssueLoader,
    showProjectIssueLoader,
    setProjectIssue,
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/projectIssue/container.js